import Phaser from 'phaser';
import {
  createGorkemVisual,
  setCharacterAnimation,
  setCharacterDirection,
  setGorkemSeated,
} from '../cafe/VisualFactory';
import type { FinaleState } from '../types';

export class Day20FinaleSystem {
  state: FinaleState = 'INACTIVE';
  readonly gorkem: Phaser.GameObjects.Container;

  constructor(
    private readonly scene: Phaser.Scene,
    private readonly yasemin: Phaser.GameObjects.Container,
    private readonly fevzi: Phaser.GameObjects.Container,
    private readonly announce: (state: FinaleState, message: string) => void,
    private readonly complete: () => void,
  ) {
    this.gorkem = createGorkemVisual(scene, 48, 176).setVisible(false);
  }

  start(): boolean {
    if (this.state !== 'INACTIVE') return false;
    this.transition('ENTERING', 'Son misafirler kapıda…');
    const warmth = this.scene.add.rectangle(640, 360, 1280, 720, 0xffc46b, 0).setDepth(4).setBlendMode(Phaser.BlendModes.SCREEN);
    this.scene.tweens.add({ targets: warmth, alpha: 0.09, duration: 1400 });

    this.yasemin.setPosition(55, 205).setScale(0.94).setDepth(27);
    this.gorkem.setVisible(true).setAlpha(1).setScale(0.9).setPosition(80, 190).setDepth(28);
    (this.yasemin.getData('ui') as Phaser.GameObjects.Container | undefined)?.setVisible(false);
    (this.gorkem.getData('ui') as Phaser.GameObjects.Container | undefined)?.setVisible(false);
    setCharacterAnimation(this.yasemin, 'walk', 'right');
    setCharacterAnimation(this.gorkem, 'enterWalk', 'right');
    this.scene.tweens.add({
      targets: this.yasemin, x: 625, y: 481, duration: 2200, ease: 'Sine.inOut',
      onComplete: () => {
        setCharacterAnimation(this.yasemin, 'idle', 'down');
        this.yasemin.setScale(0.88).setDepth(33);
      },
    });
    this.scene.tweens.add({
      targets: this.gorkem, x: 722, y: 478, scale: 0.9, duration: 2300, ease: 'Sine.inOut',
      onComplete: () => this.seatGuests(),
    });
    return true;
  }

  private seatGuests(): void {
    this.transition('SEATED', 'Bu kez masada Yasemin ile Görkem var.');
    setGorkemSeated(this.gorkem, true);
    this.gorkem.setDepth(33);
    this.scene.time.delayedCall(900, () => this.takeOrder());
  }

  private takeOrder(): void {
    this.transition('TAKING_ORDER', 'Fevzi son siparişi alıyor.');
    setCharacterAnimation(this.fevzi, 'walk', 'left');
    setCharacterDirection(this.fevzi, 'left');
    this.scene.tweens.add({
      targets: this.fevzi, x: 800, y: 515, duration: 1250, ease: 'Sine.inOut',
      onComplete: () => {
        setCharacterAnimation(this.fevzi, 'help', 'left');
        this.announce('TAKING_ORDER', 'Yasemin: Türk kahvesi ve cheesecake · Görkem: sıcak çikolata ve pasta');
        this.scene.time.delayedCall(1250, () => this.prepare());
      },
    });
  }

  private prepare(): void {
    this.transition('PREPARING', 'Fevzi siparişleri özenle hazırlıyor.');
    setCharacterAnimation(this.fevzi, 'returnWalk', 'right');
    this.scene.tweens.add({
      targets: this.fevzi, x: 1055, y: 275, duration: 900, ease: 'Sine.inOut',
      onComplete: () => {
        setCharacterAnimation(this.fevzi, 'prepareCoffee', 'down');
        this.scene.time.delayedCall(1800, () => this.carry());
      },
    });
  }

  private carry(): void {
    this.transition('CARRYING', 'Köşenin son tepsisi hazır.');
    setCharacterAnimation(this.fevzi, 'help', 'left');
    this.scene.tweens.add({
      targets: this.fevzi, x: 800, y: 515, duration: 1200, ease: 'Sine.inOut',
      onComplete: () => this.serve(),
    });
  }

  private serve(): void {
    this.transition('SERVING', 'Afiyet olsun!');
    setCharacterAnimation(this.fevzi, 'help', 'left');
    setCharacterAnimation(this.yasemin, 'happy', 'down');
    setCharacterAnimation(this.gorkem, 'reaction', 'down');
    this.scene.time.delayedCall(1300, () => {
      setCharacterAnimation(this.fevzi, 'happy', 'down');
      this.transition('ENDING', 'En güzel köşe, birlikte emek verdiğin yerdir.');
      this.scene.time.delayedCall(2600, () => {
        this.transition('COMPLETE', '20 gün tamamlandı.');
        this.complete();
      });
    });
  }

  private transition(state: FinaleState, message: string): void {
    this.state = state;
    this.announce(state, message);
  }
}
